import { PageTab } from "../page-tab"

export class LiquidityOverviewTab extends PageTab {
  readonly id = "overview"
  readonly label = "Overview"
  readonly hrefTemplate = "/liquidity/{address}"
}

export class LiquidityAddTab extends PageTab {
  readonly id = "add"
  readonly label = "Add"
  readonly hrefTemplate = "/liquidity/{address}/add"
}

export class LiquidityStakeTab extends PageTab {
  readonly id = "stake"
  readonly label = "Stake"
  readonly hrefTemplate = "/liquidity/{address}/stake"
}

export class LiquidityWithdrawTab extends PageTab {
  readonly id = "withdraw"
  readonly label = "Withdraw"
  readonly hrefTemplate = "/liquidity/{address}/withdraw"
}

export class LiquidityManageTab extends PageTab {
  readonly id = "manage"
  readonly label = "Manage"
  readonly hrefTemplate = "/liquidity/{address}/manage"
}
